import { FC } from 'react'
import styled from 'styled-components'
import { Flex } from '@/components/atoms/Grid'
import ResponsiveImage from '@/components/atoms/responsiveImage'

type CircleIconProps = {
  imageUrl: string
  alt?: string
  width: number | string
  height: number | string
}

const CircleIcon: FC<CircleIconProps> = ({
  imageUrl,
  alt = '',
  width,
  height
}) => (
  <StyledFlex
    alignItems="center"
    justifyContent="center"
    width={width}
    height={height}
  >
    <StyledDiv>
      <ResponsiveImage imageUrl={imageUrl} alt={alt} layout="fill" />
    </StyledDiv>
  </StyledFlex>
)

export default CircleIcon

const StyledDiv = styled.div`
  position: relative;
  width: 65%;
  height: 65%;
`

const StyledFlex = styled(Flex)`
  position: relative;
  border-radius: 50%;
  border: 1px solid;
  border-color: ${(props) => props.theme.colors.onBackground};
  margin: auto;
`
